var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"datetime":_vm.timestamp},domProps:{"textContent":_vm._s(_vm.timeAgoText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }